<template>
  <v-app
    id="main"
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <Header class="has-background-primary is-fixed-top" />

    <v-main>
      <v-container>
        <v-row align="center" justify="center" class="ma-2">
          <v-sheet
            elevation="1"
            class="ma-5 pa-3 tileComponent secondary"
            outlined
            rounded
          >
            <Reel></Reel>
          </v-sheet>
        </v-row>
      </v-container>

      <v-spacer></v-spacer>

      <v-container>
        <v-row align="center" justify="center">
          <v-sheet
            elevation="1"
            class="ma-3 pa-8 tileComponent secondary"
            max-width="1000"
            fluid
            outlined
            rounded
          >
            <v-row>
              <v-col cols="3">
                <v-spacer></v-spacer>
                <h1 class="text-center white--text">About Me</h1>
              </v-col>
              <v-col>
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="7">
                <p class="white--text">
                  Hi I'm Sam, <br />
                  an undergraduate Newcastle University Computer Science
                  student, with a passion for games and their development.
                  <br /><br />
                  I'm always eager to learn and improve my skills, so I can
                  create more interesting and engaging experiences.
                  <br /><br />
                </p>
                <h2 class="white--text">Skills</h2>
                <p class="white--text tab">
                  <strong> Languages:</strong> C#, Java, Python, Javascript,
                  HTML, CSS
                </p>
                <p class="white--text tab">
                  <strong> Game Engines:</strong> Created several games in
                  <b class="yellow--text">Unity</b>, currently learning some
                  Unreal Engine (and C++).
                </p>
                <p class="white--text tab">
                  <strong> Graphics:</strong> Proficent in
                  <b class="yellow--text">Blender</b> and experience with Gimp
                  and Aesprite.
                </p>
                <p class="white--text tab">
                  <strong> Other Tools:</strong> Spent a placement year in
                  Software Engineering using an
                  <b class="yellow--text">Agile Development</b> and working with
                  <b class="yellow--text">Jira & Rally</b>, as well as using
                  <b class="yellow--text">Github</b>
                </p>
              </v-col>
              <v-col>
                <v-spacer></v-spacer>
              </v-col>
              <v-col>
                <v-avatar color="white" size="200">
                  <img src="../assets/profilePic.jpg" alt="Picture of Sam" />
                </v-avatar>
              </v-col>
            </v-row>
          </v-sheet>
        </v-row>
      </v-container>

      <v-container>
        <v-row align="center" justify="center">
          <v-sheet
            elevation="1"
            class="ma-3 pa-8 tileComponent secondary"
            max-width="1000"
            fluid
            outlined
            rounded
          >
            <v-row align="center" justify="center">
              <h1 class="white--text">My Favourite Project:</h1>
            </v-row>
            <v-row align="center" justify="center">
              <h4 class="white--text">My Summer Fishing</h4>
            </v-row>
            <v-row align="center" justify="center">
              <p class="white--text">
                This is a game that I created in Unity over my Summer break.
              </p>
            </v-row>
            <v-row align="center" justify="center">
              <p class="white--text">
                Where you explore a small island and catch all the fish that inhabit it.
              </p>
            </v-row>
            <v-row align="center" justify="center">
              <v-flex v-if="!isMobile()">
              <v-card class="mx-auto" max-width="990">
                <v-img
                  src="../assets/msfGif1.gif"
                  alt=""
                  contain
                  max-height="700px"
                  max-width="1050px"
                >
                </v-img>
                
              </v-card>
              </v-flex>
              <v-card-actions class="justify-center">
                  <v-btn color="primary" href="https://samcoleman.itch.io/my-summer-fishing" target="_blank">
                    Play Here
                  </v-btn>
                </v-card-actions>
            </v-row>
          </v-sheet>
        </v-row>
      </v-container>

      <v-container>
        <v-row align="center" justify="center">
          <v-sheet
            elevation="1"
            class="ma-3 pa-8 tileComponent secondary"
            max-width="1000"
            outlined
            rounded
          >
            <v-row align="center" justify="center">
              <h1 class="white--text">Personal Projects</h1>
            </v-row>
            <v-row align="center" justify="center">
              <p class="white--text">
                In my spare time I enjoy learning more about game development
                and improving my skills. <br />
                These are some projects I've worked on.
              </p>
            </v-row>
            <v-row align="center" justify="center">
              <template v-for="game in games">
                <v-col v-bind:key="game">
                  <GameCard
                    v-bind:key="game"
                    v-bind:game="game"
                    class="ma-5"
                  ></GameCard>
                </v-col>
              </template>
            </v-row>
            <v-row align="center" justify="center">
              <h3 class="white--text">
              <a href="https://samcoleman.itch.io/" target="_blank">See All Games</a>
            </h3>
            </v-row>
          </v-sheet>
        </v-row>
      </v-container>

      <v-container>
        <v-row align="center" justify="center">
          <v-sheet
            elevation="1"
            class="ma-3 pa-8 tileComponent secondary"
            max-width="1500"
            outlined
            rounded
          >
            <h1 class="text-center white--text">Contact Me</h1>

            <p class="white--text">
              Check out my
              <a href="./CVSamuelColeman.pdf" target="_blank">résumé</a>
            </p>
            <p class="white--text">
              Feel free to send me a messsage at
              <a v-on:click="SendEmail" target="_blank"
                >hello-samcoleman@outlook.com</a
              >.
            </p>
            <p class="white--text">
              Or reach out on one of the social media links below.
            </p>
            <v-row align="center" justify="center">
              <v-btn
                class="mx-2"
                href="https://www.linkedin.com/in/samuel-coleman-09412b1bb/"
                target="_blank"
                icon
              >
                <font-awesome-icon icon="fa-brands fa-linkedin" size="xl" />
              </v-btn>

              <v-btn
                class="mx-2"
                href="https://twitter.com/samc0leman"
                target="_blank"
                icon
              >
                <font-awesome-icon icon="fa-brands fa-twitter" size="xl" />
              </v-btn>

              <v-btn class="mx-2" v-on:click="SendEmail" target="_blank" icon>
                <font-awesome-icon icon="fa-solids fa-envelope" size="xl" />
              </v-btn>
            </v-row>
          </v-sheet>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";
import Reel from "@/components/Reel.vue";
import GameCard from "@/components/GameCard.vue";

export default {
  methods: {
    SendEmail: function () {
      window.location = "mailto:hello-samcoleman@outlook.com";
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "200px";
        case "sm":
          return "200px";
        case "md":
          return "200px";
        case "lg":
          return "200px";
        case "xl":
          return "200px";
      }
      return "650px";
    },

    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "90px";
        case "sm":
          return "90px";
        case "md":
          return "90px";
        case "lg":
          return "90px";
        case "xl":
          return "90px";
      }
      return "650px";
    },
  },

  components: {
    Header,
    Reel,
    GameCard,
  },

  data() {
    return {
      games: [
        {
          name: "Procedural City Generator",
          desc: "A tool that utilises L-Systems to procedural generate a city enviroment.",
          devdesc:
            "This is a demo of my final year project, titled 'Procedurally Generating Urban Enviroments for Video Games' which had me researching the usage of different procedural generation techniques in video games such as L-Systems, and Shape Grammar. Using this knowledge I went on to create a procedural city generation tool, which utilises L-Systems and modular assets to procedurally generate a city.",
          shortDesc:
            "A tool that utilises L-Systems to procedural generate a city enviroment.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Final year Project",
          gif: require("../assets/cityGenerationGif2.gif"),
          img: require("../assets/cityGeneratorCover.png"),
          url: "https://samcoleman.itch.io/procedural-city-generator",
        },
        {
          name: "Space Defender",
          desc: "An endless wave first person shooter, where the objective is to protect your ship as long as you can.",
          devdesc:
            "This is piece of coursework that I completed for my Game Technologies and Simulations module. The module gave us an understanding of how physics engines operate and went in to topics such as newtonian physics and collision detection/resolution. We also explored various AI techniques and algorithms used in game development such as flocking, A* pathfinding and Min Max to name a few.",
          shortDesc:
            "An endless wave first person shooter prototype create for a university module.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Made over 4 weeks",
          gif: require("../assets/spaceGameGif2.gif"),
          img: require("../assets/SpaceCoverArt.png"),
          url: "https://samcoleman.itch.io/space-defender-university-assignment",
        },
        {
          name: "My Summer Fishing",
          desc: "A third person fishing game, where the objective is to explore the surroundings and catch all the fish.",
          devdesc:
            "This is a project that I worked on over my summer break from university. I wanted to take what I had learnt so far studying Unity Game Development, and create a more subtantial game that was something I myself would be interested in playing. One large take away I had from this project was learning to implement state machines in my game, which is how I programmed the fish. I also got a deeper understanding of creating shaders using shader graph.",
          shortDesc:
            "Explore a small island and catch all the fish that inhabit it.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Made over the Summer break",
          gif: require("../assets/msfGif1.gif"),
          img: require("../assets/msfCoverArt.png"),
          url: "https://samcoleman.itch.io/my-summer-fishing",
        },
        {
          name: "Where'd my socks go?",
          desc: "A first person scavengar hunt, where you are tasked to find all your odd socks laying around the house in 3 minutes.",
          devdesc:
            "I created this game in around 3 weeks, I wanted to make an arcade style game with a straight forward goal and a time limit. It also allowed me to learn more about different aspects of unity and game development, such as lighting and post-processing.",
          shortDesc:
            "Try to find all of the lost socks around the house before time runs out.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Made in 3 weeks",
          gif: require("../assets/sockGif1.gif"),
          img: require("../assets/SocksCoverArt.png"),
          url: "https://samcoleman.itch.io/whered-my-socks-go",
        },
        /*{
          name: "Stone Skipping",
          desc: "A third person game about finding the perfect stone to skim, and seeing how far you can skim it.",
          devdesc:
            "This is a game that I challenged myself to make within a week, learning how to keep the scope small and reduce creep, as well as learning to prioritise. I also used creating this game as a vehicle to improve my skills of using physics in games.",
          shortDesc:
            "Find the perfect skimming stone and see how far you can skim it.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Made in 1 weeks",
          gif: require("../assets/stoneGif1.gif"),
          img: require("../assets/StoneCoverArt.png"),
          url: "https://samcoleman.itch.io/stone-skipping",
        },
        {
          name: "A night at the office",
          desc: "A first person comedy game, where you explore an office of skeletons, who share their anxites and burdens with you, very scary!",
          devdesc:
            "This is a game I made in a month for Halloween, it was one of my first experiences making a 3D first person game, and was also my first time learning about various aspects of game development, such as animation. The premise for the game was inspired by Grace Bruxners games, which often include small surreal enviroments to explore and peculiar characters to speak to.",
          shortDesc:
            "Explore an office of unusual residents in this halloween game.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Made in 1 month",
          gif: require("../assets/officeGif1.gif"),
          img: require("../assets/OfficeCoverArt.png"),
          url: "https://samcoleman.itch.io/a-night-at-the-office",
        },*/
        {
          name: "Senryu Nights",
          desc: "An online game, where you write haiku's and senryu's about three different scenes and share them anonymously with the world.",
          devdesc:
            "This is the first game that I had released online. I wanted to create a game that was shaped by those that played it, and would be something I can share with family and friends. I decided upon writing shorts poems, as its something I was curious about, but writing them was a bit embarrasing. So with this game I created a space where they could be written and shared freely.",
          shortDesc:
            "Read and write short poems based on different enviroments.",
          gameLang: "C#",
          gameArt: "Blender",
          gameEngine: "Unity",
          gameDuration: "Made in 1 month",
          gif: require("../assets/senryuNightsGif1.gif"),
          img: require("../assets/SenryuCoverArt.png"),
          url: "https://samcoleman.itch.io/senryu-nights",
        },
      ],
      avatarImg: require("../assets/logo.png"),
    };
  },
};


</script>

<style scoped>
.tab {
  margin-left: 10px;
}
.v-img {
  max-height: imageHeight !important;
}
</style>
